var _defs, _path, _path2, _path3, _rect, _rect2, _path4, _rect3, _path5, _path6, _path7, _path8, _rect4, _rect5, _path9, _rect6, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _polygon, _path16, _path17, _rect7, _path18, _path19, _path20, _path21, _path22, _rect8, _path23, _path24, _path25, _polyline, _polygon2, _path26, _path27, _path28, _polyline2, _polyline3, _polyline4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpainFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffce31;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ed4c5c;\n      }\n\n      .cls-3 {\n        fill: #c7b500;\n      }\n\n      .cls-4 {\n        fill: #005bbf;\n      }\n\n      .cls-5 {\n        fill: #c8b100;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,75c0,14.7,4.2,28.4,11.6,40h126.7c7.3-11.6,11.6-25.3,11.6-40s-4.2-28.4-11.6-40H11.6C4.3,46.6,0,60.3,0,75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.4,35C125.1,14,101.7,0,75,0S24.9,14,11.6,35h126.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.6,115c13.3,21,36.7,35,63.4,35s50.1-14,63.4-35H11.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 18.2,
    y: 66.8,
    width: 8,
    height: 4.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 18.1,
    y: 99.7,
    width: 8.2,
    height: 4.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.4,92.6c-.8.5-1.4,1-1.3,1.2,0,.2.3.4.7.6.6.4.9,1.1.7,1.5.5-.4.8-1,.8-1.6s-.3-1.3-.8-1.7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 19.2,
    y: 71.1,
    width: 5.8,
    height: 28.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31,81.8c-1.3-.5-3.4-.9-5.9-1-.9,0-1.8,0-2.8.3-3.5.6-6.1,2-5.9,3.1h0c0,0-1.3-3-1.3-3-.2-1.3,2.7-2.8,6.6-3.5,1.2-.2,2.4-.3,3.4-.3,2.5,0,4.6.3,5.9.8v3.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.2,85.4c-1.6-.1-2.7-.5-2.8-1.2,0-.5.4-1.1,1.4-1.7.4,0,.9.1,1.4.1v2.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.1,83.2c1,.2,1.8.4,2.1.7h0c.2.4-.7,1.2-2.2,2.1v-2.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.6,90.9c-.2-.5,1.4-1.4,3.6-2.2,1-.4,1.9-.7,2.9-1.2,3.1-1.4,5.4-2.9,5.1-3.5h0c0,0,.4,2.9.4,2.9.3.5-1.8,2.1-4.7,3.4-.9.4-2.8,1.1-3.7,1.5-1.6.6-3.2,1.6-3.1,2l-.5-2.9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 71.6,
    y: 66.8,
    width: 8,
    height: 4.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 71.5,
    y: 99.7,
    width: 8.2,
    height: 4.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.4,92.6c.8.5,1.4,1,1.3,1.2,0,.2-.3.4-.7.6-.6.4-.9,1.1-.7,1.5-.5-.4-.8-1-.8-1.6,0-.7.3-1.3.8-1.7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.7,
    y: 71.1,
    width: 5.8,
    height: 28.6
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.8,81.8c1.3-.5,3.4-.9,5.9-1,.9,0,1.8,0,2.8.3,3.5.6,6.1,2,5.9,3.1h0c0,0,1.3-3,1.3-3,.2-1.3-2.7-2.8-6.6-3.5-1.2-.2-2.4-.3-3.4-.3-2.5,0-4.6.3-5.9.8v3.5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.6,85.4c1.6-.1,2.7-.5,2.8-1.2,0-.5-.4-1.1-1.4-1.7-.4,0-.9.1-1.4.1v2.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.7,83.2c-1,.2-1.8.4-2.1.7h0c-.2.4.7,1.2,2.2,2.1v-2.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.2,90.9c.2-.5-1.4-1.4-3.6-2.2-1-.4-1.9-.7-2.9-1.2-3.1-1.4-5.4-2.9-5.1-3.5h0c0,0-.4,2.9-.4,2.9-.3.5,1.8,2.1,4.7,3.4.9.4,2.8,1.1,3.7,1.5,1.6.6,3.2,1.6,3.1,2l.5-2.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.7,50.7c4.8,0,14.4,1.1,18,4.4-3.7,9-9.8,5.3-17.9,5.3-8.1,0-14.2,3.7-17.9-5.3,3.5-3.3,13.1-4.4,17.8-4.4s-2.4,0,0,0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.1,60.7c-3.1-1.7-7.5-2.1-12.3-2.1-4.8,0-9.1.4-12.2,2.1l1.1,4.2c2.8.8,6.7,1.4,11.1,1.4,4.4,0,8.3-.5,11.1-1.4l1.1-4.2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.3,50.1c-1-.8-2.9-1.4-4.8-1.4s-1.5,0-2.2.2c.1.1-1.4-2.1-4.9-2.1s-2.4.3-3.2.8h0c-.1-.7-.7-1.1-1.3-1.1s-1.2.4-1.3,1h0c-.9-.4-2-.7-3.2-.7-3.4,0-5,2.2-4.9,2.1-.7-.2-1.4-.2-2.2-.2-11.5,0-5.6,7.8-5.6,7.8l.9-1.5c-2.7-3.5-.4-5.6,4.7-5.6s1.2,0,1.8.2c-1.7,2.6,1.5,4.7,1.5,4.7l.7-1.2c-1.8-1.2-2-5.5,3-5.5s2.4.3,3.2.9c0,.3-.3,3.6-.5,4.3l1.9,1.8,1.9-1.8c-.3-.7-.5-4-.5-4.3.8-.5,1.9-.9,3.2-.9,5.1,0,5.3,4.3,3,5.5l.7,1.2s2.7-2.2,1.5-4.7c.6-.1,1.2-.2,1.8-.2,6,0,6.4,4.4,4.7,5.6l.9,1.5s2.6-3.4-.8-6.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.2,45.2c0-.8.7-1.5,1.6-1.5s1.6.7,1.6,1.5-.7,1.5-1.6,1.5c-.9,0-1.6-.7-1.6-1.5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "48.4 41 48.4 41.8 47.5 41.8 47.5 42.6 48.4 42.6 48.4 43.7 48.4 45 47.3 45 47.2 45.2 47.4 45.8 47.4 45.8 50.3 45.8 50.3 45.8 50.4 45.2 50.3 45 49.3 45 49.3 43.8 49.3 42.6 50.1 42.6 50.1 41.8 49.3 41.8 49.3 41 48.4 41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.8,65.7c-4,0-7.6-.5-10.3-1.2,2.7-.7,6.3-1.1,10.3-1.1,4,0,7.6.4,10.3,1.1-2.7.7-6.3,1.2-10.3,1.2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49,109c-4.7,0-9.3-1.2-13.2-3.1-2.9-1.4-4.8-4.3-4.8-7.6v-11.9h36v11.9c0,3.3-1.9,6.2-4.8,7.6-3.9,1.9-8.5,3.1-13.2,3.1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 48.9,
    y: 66.4,
    width: 18,
    height: 20
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.9,98.4c0,4.7-4,8.5-9,8.5s-9-3.8-9-8.5v-12h18v12"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.8,105.4c.6.3,1.3.8,2.2,1v-20.4h-2.2v19.4h0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.9,98.2c0,2.5,1.1,4.4,2.1,5.6v-17.7h-2v12.1Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.9,106.8c.8,0,1.4,0,2.1,0v-20.9h-2.1v20.9Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.8,106.4c.8-.2,1.8-.7,2.2-.9v-19.5h-2.1v20.4Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.9,
    y: 66.4,
    width: 18,
    height: 20
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.9,103.6c.9-.8,1.7-2.5,2-4.6v-13.1c0,0-2.1,0-2.1,0v17.6Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67,86.4v12c0,4.7-4,8.5-9,8.5s-9-3.8-9-8.5v-12h18"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.4,69.9c.6,1.5.6,5.2-1.6,4.4.4.1.6,2,1.4,2.9,1.3,1.5,2.8.2,2.4-1.5-.6-2.8-.3-4.5.3-7.2,0,.4,1.3.3,1.7-.3-.3.7-.4,1.7-.1,1.7-.4.7-1.8,1.9-1.9,2.7-.2,1.7,2.4,5.1-.5,5.8-2,.4-.8,2,0,2.8,0,0-.9,3.2-.5,3-2.1.8-1.4-.9-1.4-.9.9-2.9-1.6-3.2-1.4-3.7-2.5-.1.3,2.3-2.1,2.3s-1.4.4-1.4.4c-2.7-.2-1.1-2.8-.3-2.5.8.4,1.5,1.6,1.6-.1,0,0-1.3-2,1.9-2-1.2,0-2.1-1.1-2.5-2.2-.4.3-1.4,1.5-4,1.7,0,0-.8-2.7,0-2.3.9.4,1.6.4,2.5-.5-.6-.6-3.5-1.8-3.1-3.6.1-.5,1.5-1.2,1.5-1.2-.2,1.2.4,2.4,2,2.6,2.1.2,1.2-.5,1.4-1.1.2-.6,1.7.2,1.3-1,0-.2-1.8-.6-1.2-1.1,1.4-1.3,3.1-.5,4.2.8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "49 106.5 48.5 105.2 49 103.8 49.6 105.2 49 106.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "36.2 70.7 36.2 72 36.8 72 36.8 73 35.5 73 35.5 75.6 36.2 75.6 36.2 80.9 34.9 80.9 34.9 83.6 45 83.6 45 80.9 43.7 80.9 43.7 75.6 44.4 75.6 44.4 73 43.1 73 43.1 72 43.7 72 43.7 70.7 41.2 70.7 41.2 72 41.8 72 41.8 73 40.6 73 40.6 70.1 41.2 70.1 41.2 68.7 38.7 68.7 38.7 70.1 39.3 70.1 39.3 73 38.1 73 38.1 72 38.7 72 38.7 70.7 36.2 70.7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.4,89.9h4.3l-4.3,4.3v-4.3ZM63.5,100.2l-5-5,5-5v10ZM58.4,103.3v-7l4.8,4.8-4.8,2.2ZM52.7,101.1l4.8-4.8v7l-4.8-2.2ZM52.3,90.3l5,5-5,5v-10ZM57.5,89.9v4.3s-4.3-4.3-4.3-4.3h4.3ZM64.4,101.5v-12.5h-12.9v12.5l6,2.8h0s0,0,0,0h.8s6-2.8,6-2.8Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.1,86.3c0-3.6,2.6-6.6,5.8-6.6s5.8,2.9,5.8,6.6-2.6,6.6-5.8,6.6-5.8-2.9-5.8-6.6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.9,86.3c0-2.7,1.8-4.8,4.1-4.8s4.1,2.2,4.1,4.8-1.8,4.8-4.1,4.8-4.1-2.2-4.1-4.8"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "47 83 46 85.7 46.7 86 46.3 86.9 47.7 86.9 47.4 86 48.1 85.7 47 83"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "50.8 83 49.8 85.7 50.5 86 50.2 86.9 51.5 86.9 51.2 86 51.9 85.7 50.8 83"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "48.9 86.3 47.9 89 48.6 89.3 48.3 90.2 49.6 90.2 49.3 89.3 50 89 48.9 86.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpainFlag);
export default __webpack_public_path__ + "static/media/SpainFlag.4a17f77b296c062a73b85a05d6a3c12f.svg";
export { ForwardRef as ReactComponent };